
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from "react-router-dom";
// import { StoreProvider } from 'easy-peasy';

import './fonts/gilroy/woff/gilroy-light.woff';
import './fonts/gilroy/woff/gilroy-regular.woff';
import './fonts/gilroy/woff/gilroy-medium.woff';
import './fonts/gilroy/woff/gilroy-semibold.woff';
import './fonts/gilroy/woff/gilroy-bold.woff';
import './fonts/gilroy/woff/gilroy-extrabold.woff';
import "@fontsource/roboto";

import './index.css';
import 'mdb-react-ui-kit/dist/css/mdb.min.css'


import App from './App';

ReactDOM.render(
  <React.StrictMode>
    {/* <StoreProvider store={store}> */}
    <BrowserRouter>
      
        <App />
      
    </BrowserRouter>
    {/* </StoreProvider> */}
  </React.StrictMode>,
  document.getElementById('root')
);